<template>
  <div :id="`${source}_call_analytics`" class="flex flex-col gap-2 pb-3">
    <AnalyticsFilterComponent :allowed-filters="callsAllowedFilters" />

    <div class="flex flex-col gap-2">
      <CallAnalyticsGrid />
      <CallEngagementActivity :type="analyticTypes.CHART" />
      <CallDispositionAnalytics />
      <CallEngagementActivity :type="analyticTypes.TABLE" />
    </div>
  </div>
</template>

<script setup>
import {
  analyticTypes,
  callsAllowedFilters,
} from "@/src/constants/analyticConstants.js";
import AnalyticsFilterComponent from "@/src/views/analytics/v2/AnalyticsFilterComponent.vue";
import CallAnalyticsGrid from "@/src/views/analytics/v2/call_analytics/CallAnalyticsGrid.vue";
import CallEngagementActivity from "@/src/views/analytics/v2/call_analytics/CallEngagementActivity.vue";
import CallDispositionAnalytics from "@/src/views/analytics/v2/call_analytics/CallDispositionAnalytics.vue";

const props = defineProps({
  source: { type: String, required: true },
});
</script>
